import { createRouter, createWebHistory } from 'vue-router'
import { isNrwVisible } from '@/utils/featureHosts'
//import { useAuthStore } from '@/stores/authStore'

const router = createRouter({
  history: createWebHistory(),
  //history: createWebHistory('/renewal/'),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
    },
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/DashboardView.vue'),
      meta: { titleKey: 'nav.monitoring' },
    },
    {
      path: '/water-leak',
      name: 'water-leak',
      component: () => import('@/views/LeakDetectionView.vue'),
      meta: { titleKey: 'nav.leak' },
    },
    {
      path: '/logger',
      name: 'logger',
      component: () => import('@/views/LoggerView.vue'),
      meta: { titleKey: 'nav.logger' },
    },
    {
      path: '/gis-master',
      name: 'gis-master',
      component: () => import('@/views/GisMasterView.vue'),
      meta: { titleKey: 'nav.gis_master' },
    },
    {
      path: '/dma',
      name: 'dma',
      component: () => import('@/views/DmaView.vue'),
      meta: { titleKey: 'nav.gis_master' },
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: () => import('@/views/MaintenanceView.vue'),
      meta: { titleKey: 'nav.maintenance' },
    },
    // NRW — 로컬은 항상, 운영은 dev.neverlosewater.com + 고객사 0·16 만. LeftNav 노출 조건과 동일하게 beforeEach 에서 가드
    {
      path: '/nrw',
      name: 'nrw',
      component: () => import('@/views/NrwView.vue'),
      meta: { titleKey: 'nav.nrw', nrwOnly: true },
    },
    {
      path: '/similar-sites',
      name: 'similar-sites',
      component: () => import('@/views/SimilarSitesView.vue'),
      meta: { titleKey: 'header.similar_sites' },
    },
    // AI Agent — 관리자(customer_id===1) 전용 풀스크린 화면. router.beforeEach 에서 권한 가드
    {
      path: '/agent-ai',
      name: 'agent-ai',
      component: () => import('@/views/AiAgentView.vue'),
      meta: { titleKey: 'nav.ai_agent', adminOnly: true },
    },
    // 관리자 메뉴 — 고객사가 Wiplat 인 경우만 헤더에 노출 (실제 화면은 후속)
    {
      path: '/admin/customers',
      name: 'admin-customers',
      component: () => import('@/views/admin/CustomerView.vue'),
      meta: { titleKey: 'header.admin_customers' },
    },
    {
      path: '/admin/workers',
      name: 'admin-workers',
      component: () => import('@/views/admin/WorkerView.vue'),
      meta: { titleKey: 'header.admin_workers' },
    },
    {
      path: '/admin/devices',
      name: 'admin-devices',
      component: () => import('@/views/admin/DeviceView.vue'),
      meta: { titleKey: 'header.admin_devices' },
    },
    {
      path: '/admin/alarms',
      name: 'admin-alarms',
      component: () => import('@/views/admin/AlarmView.vue'),
      meta: { titleKey: 'header.admin_alarms' },
    },
    {
      path: '/admin/mnp',
      name: 'admin-mnp',
      component: () => import('@/views/admin/MnpView.vue'),
      meta: { titleKey: 'header.admin_mnp' },
    },
    {
      path: '/admin/press-datacheck',
      name: 'admin-press-datacheck',
      component: () => import('@/views/admin/DataCheckView.vue'),
      meta: { titleKey: 'header.admin_press_datacheck' },
    },
  ],
})

router.beforeEach((to) => {
  const accessToken = sessionStorage.accessToken
  if (to.name === 'login') {
    if (accessToken) {
      const redirect = typeof to.query.redirect === 'string' ? to.query.redirect : '/'
      if (redirect.startsWith('/api/') || redirect.startsWith('/node/api/')) return { name: 'dashboard' }
      return redirect
    }
    return true
  }

  if (!accessToken) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  // adminOnly 라우트 — 로그인 사용자의 home customer_id 가 1(Wiplat)인 경우에만 진입
  if (to.meta?.adminOnly && Number(sessionStorage.customer_id) !== 1) {
    return { name: 'dashboard' }
  }

  // nrwOnly 라우트 — 로컬은 항상, 운영은 dev.neverlosewater.com + 고객사 0·16 일 때만 진입 (주소 직접 입력도 차단)
  if (to.meta?.nrwOnly && !isNrwVisible()) {
    return { name: 'dashboard' }
  }

  return true
})

export default router
